import Lottie from 'react-lottie-player';
import loaderData from './loader.json';

export function Loader() {
  return (
    <Lottie
      loop
      play
      animationData={loaderData}
      rendererSettings={{
        preserveAspectRatio: 'xMidYMid',
      }}
      style={{ height: '100px' }}
    />
  );
}
